<template>
  <div class="creation-demand-step-experience-level">
    <form @submit.prevent="save">
      <h2 class="step-title-optional">
        {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@EXPERIENCE_LEVEL_TITLE")) }}
      </h2>
      <section>
        <div class="creation-experience-level">
          <div class="q-pa-md">
            <div class="q-gutter-sm creation-experience-radios">
              <div>
                <QRadio
                  v-model="novicesAllowed"
                  left-label
                  :val="true"
                  :label="$t('ETAB.PAGES.DEMANDS.CREATION.@RECAP_NOVICES_IS_ALLOWED')"
                  size="md"
                  class="text-bold creation-experience-radio"
                  @update:model-value="setNovicesAllowed(novicesAllowed)"
                />
              </div>
              <div>
                <QRadio
                  v-model="novicesAllowed"
                  left-label
                  :val="false"
                  :label="$t('ETAB.PAGES.DEMANDS.CREATION.@RECAP_NOVICES_NOT_ALLOWED')"
                  size="md"
                  class="text-bold creation-experience-radio"
                  @update:model-value="setNovicesAllowed(novicesAllowed)"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <ExtraTipbox class="margin-15 font-090">
        <span>{{ $t("ETAB.PAGES.DEMANDS.CREATION.@EXPERIENCE_LEVEL_TIPS") }}</span>
      </ExtraTipbox>
      <transition appear enter-active-class="animated fadeIn slower delay-1s" leave-active-class="animated fadeOut">
        <section class="q-footer q-layout__section--marginal fixed-bottom">
          <div>
            <QBtn
              color="secondary"
              class="full-width btn-navigation"
              :label="$t('ETAB.BUTTONS.@NEXT')"
              no-caps
              type="submit"
              :loading="loading"
              :disabled="submitting"
            />
          </div>
        </section>
      </transition>
    </form>
  </div>
</template>
<script>
  import { CreationStepNovicesModel, ICreationStepNovices } from "@core/models";

  export default {
    props: {
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        submitting: false,
        novicesAllowed: undefined,
      };
    },
    computed: {
      stepDataModel() {
        return new CreationStepNovicesModel(this.stepData);
      },
    },
    created() {
      this.novicesAllowed = this.stepDataModel.getNovicesAllowed();
    },
    methods: {
      setNovicesAllowed(value) {
        this.novicesAllowed = value;
      },
      save() {
        this.submitting = true;
        this.$emit("saveStep", { [ICreationStepNovices.novicesAllowed]: this.novicesAllowed });
        setTimeout(() => {
          this.submitting = false;
        }, 1000);
      },
    },
  };
</script>

<style lang="scss">
  .creation-demand-step-experience-level {
    margin-bottom: 80px;
    .creation-experience-level {
      .creation-experience-radios {
        display: flex;
        flex-direction: column;
        align-items: left;
        .creation-experience-radio {
          width: 70px;
        }
      }
    }
  }
</style>
